<template>
  
   <div class="content-wrap">
     <lnb v-if="!isPopup()"/>
        <div :class="['flexible-content', heightMaxClass]">
            <div id="content" :class="isPopup() ? '' : 'app-content'" role="main" >
              <Header v-if="!isPopup()" />
              <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './Header.vue'
import Lnb from './Lnb.vue'
export default {
  components: { Lnb, Header },
  data(){
    return {
      heightMaxClass: ''
    }
  },
  watch: {
    $route (newVal, oldBal) {
      
      this.maxClass = '';
      if(newVal.name == 'Indicator') {
        this.heightMaxClass = 'height-max'
      }
    },
    
  },
  methods : {
    isPopup(){
      let path = this.$route.path;
      if(path == '/app/booking/calendar') return true;
      else return false;
    }
  }
}
</script>

<style>

</style>